import { Box, Button, Grid, Stack, SvgIcon } from '@mui/material';
import { Plus } from '../../../assets';
import PageTitle from '../../../components/shared/PageTitle';
import React from 'react';
import { TransactionsContext, TransactionsContextValues } from '../contexts/TransactionsContext';
import { useTranslation } from 'react-i18next';

const TransactionTopArea = () => {
  const { isMobile,
    hasPermissionToCreateNew,
    handleConfirmModal,
  } = React.useContext(TransactionsContext) as TransactionsContextValues;

  const { t } = useTranslation('common');

  return (
    <Grid container>
      <Stack width='100%'
        spacing={2}
        direction={isMobile ? 'column' : 'row'}
        sx={{
          justifyContent: 'space-between',
        }}>
        <Box width={isMobile ? '100%' : 'auto'}>
          <PageTitle subTitle='Record and track your transactions'>{t('transactions.title')}</PageTitle>
        </Box>
        {hasPermissionToCreateNew && (
          <Box width={isMobile ? '100%' : 'auto'}
            sx={{
              display: 'flex',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}>
            <Button
              variant="primary"
              size="lg"
              sx={{
                mb: { xs: 4, md: 0 },
              }}
              onClick={() => handleConfirmModal()}
              startIcon={<SvgIcon><Plus fill="white" /></SvgIcon>}
            >
              {t('createNewTransactionBtn')}
            </Button>
          </Box>
        )}
      </Stack>
    </Grid>
  );
};

export default TransactionTopArea;